// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"553":"TimelapseScreen","680":"LoginScreen"}[chunkId] + "." + {"553":"974a5e50","680":"c11055c8"}[chunkId] + ".chunk.css";
};